<template>
    <div class="tableIngresos">
        <vs-row>
            <vs-col w="12">
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <form target="_blank" method="post" action="/reportesMovimientos/getIngresos">
                    <input type="hidden" name="cicloEscolar" :value="filtrosForm.cicloEscolar">

                    <input v-for="codigos in filtrosForm.codigoDetalle" :key="codigos.id" v-if="filtrosForm.codigoDetalle" type="hidden" name="codigoDetalle[]" :value="codigos">

                    <input v-if="filtrosForm.fechaFinal" type="hidden" name="fechaFinal" :value="filtrosForm.fechaFinal">

                    <input v-if="filtrosForm.fechaInicio" type="hidden" name="fechaInicio" :value="filtrosForm.fechaInicio">

                    <input v-for="fuentes in filtrosForm.fuenteMovimiento" :key="fuentes.id"  v-if="filtrosForm.fuenteMovimiento" type="hidden" name="fuenteMovimiento[]" :value="fuentes">

                    <input v-for="grupos in filtrosForm.grupo" :key="grupos.id" type="hidden" name="grupo[]" :value="grupos">

                    <input type="hidden" name="institucion" :value="filtrosForm.institucion">

                    <input v-for="metodos in filtrosForm.metodoPago" :key="metodos.id"  v-if="filtrosForm.metodoPago" type="hidden" name="metodoPago[]" :value="metodos">

                    <input type="hidden" name="type_response" value="file">
                    <input type="hidden" name="_token" :value="csrf_token">
                    <vs-button
                        color="#55ce63"
                        relief
                        v-if="users[0]"
                        :loading="loadingExcel"
                        type="submit"
                        class="ml-auto"
                    >
                        <i class="fas fa-download mr-2"></i> Descargar reporte
                    </vs-button>
                </form>
                <div style="max-width: 100%;">
                    <h5 v-if="infoCard.alumnosTotal">Número total de alumnos: <strong>{{ infoCard.alumnosTotal}}</strong></h5>
                    <vs-table striped clas="table-responsive" 
                        v-dragscroll="{ target: '.vs-table', active: true }">
                        <template #thead>
                        <vs-tr>
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                            Alumno
                            </vs-th>
                            <vs-th>
                            Ciclo Escolar
                            </vs-th>
                            <vs-th>
                                No. Autorización
                            </vs-th>
                            <vs-th>
                                Código de detalle
                            </vs-th>
                            <vs-th>
                                Método de pago
                            </vs-th>
                            <vs-th>
                                Fuente
                            </vs-th>
                            <vs-th>
                                Fecha
                            </vs-th>
                            <vs-th v-if="!permisos.includes('ocultar-monto-reporte-ingresos')">
                                Monto
                            </vs-th>
                            <vs-th>
                                Facturado
                            </vs-th>
                            <vs-th v-if="!permisos.includes('ocultar-monto-reporte-ingresos')">
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(users, search)"
                            :data="tr"
                            style="vertical-align: top"
                        >
                            <vs-td>
                                <md-content class="cienCincuenta d-block">
                                    <div class="estatus-alumno mb-2" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                        <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                                    </div>
                                    <div class="d-flex">
                                        <div>
                                            <vs-avatar circle>
                                                <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                            </vs-avatar>
                                        </div>
                                        <div class="ml-2">
                                            <strong>{{ tr.nombre }}</strong>
                                            <span style="text-transform: uppercase; font-size: 11px;">Matrícula</span>
                                            <strong>{{ tr.matricula }}</strong>
                                        </div>
                                    </div>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cien d-block">
                                    <p><strong>{{tr.cicloEscolar}}</strong></p>
                                    <p class="mb-0"><small>PROGRAMA</small></p>
                                    <p><strong>{{ tr.programa }}</strong></p>
                                    <p class="mb-0"><small>GRUPO</small></p>
                                    <p><strong>{{ tr.grupo }}</strong></p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cien" v-for="info in tr.ingresos" :key="info.id">
                                    <p> {{ info.noAutorizacion }} </p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="trecientos" v-for="info in tr.ingresos" :key="info.id">
                                    <p> {{ info.codigoDetalle }} <span v-if="info.subcategoria">({{info.subcategoria}})</span> </p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <div v-for="info in tr.ingresos" :key="info.id">
                                    <md-chip v-if="info.metodoPago" class="mb-1 fontMedium mini-chip" :class="'col-' + colorFactura[info.metodoPago]"><strong> {{ info.metodoPago }} </strong></md-chip>
                                </div>
                            </vs-td>
                            <vs-td>
                                <md-content class="cienCincuenta" v-for="info in tr.ingresos" :key="info.id">
                                    <p> {{ info.fuente }} </p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cien" v-for="info in tr.ingresos" :key="info.id">
                                    <p><i class="far fa-calendar-alt"></i> {{ info.fecha }} </p>
                                </md-content>
                            </vs-td>
                            <vs-td v-if="!permisos.includes('ocultar-monto-reporte-ingresos')">
                                <md-content class="cien" v-for="info in tr.ingresos" :key="info.id">
                                    <p>{{ info.monto | currency }} </p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <div v-for="info in tr.ingresos" :key="info.id">
                                    <md-chip class="mb-1 fontMedium mini-chip" :class="getColor(getFacturado(info))"><strong>{{getFacturado(info)}} </strong></md-chip>
                                </div>
                            </vs-td>
                            <vs-td v-if="!permisos.includes('ocultar-monto-reporte-ingresos')">
                                <md-content class="cienCincuenta">
                                        <vs-button
                                            success
                                            flat
                                            :href="'/estado-de-cuenta/' + tr.persona_id + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar"
                                            blank
                                        >
                                            Gestion de finanzas
                                        </vs-button>
                                </md-content>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import axios from 'axios'
import { dragscroll } from 'vue-dragscroll'
import reportes from '../../../api/requests/reportes.js'
export default {
    props:[
        'users',
        'cicloEscolar',
        'institucion',
        'ciclosEscolares',
        'instituciones',
        'filtros',
        'infoCard',
        'csrf_token',
        'filtrosForm',
        'permisos'
    ],
    data(){
        return{
            search: '',
            active: 0,
            statusColores: {
                "Facturado" : "green",
                "No facturado": "red"
            },
            colorFactura: {
                "Efectivo": "green",
                "Cheque nominativo": "yellow",
                "Transferencia electrónica de fondos" : "blue",
                "Tarjeta de crédito" : "red",
                "Monedero electrónico": 'purple',
                "Dinero electrónico": "gray",
                "Vales de despensa": "pink",
                "Dación en pago": "brown",
                "Pago por subrogación": "green",
                "Pago por consignación": "yellow",
                "Condonación" : "blue",
                "Compensación" : "red",
                "Novación": 'purple',
                "Confusión": "gray",
                "Remisión de deuda": "pink",
                "Prescripción o caducidad": "brown",
                "A satisfacción del acreedor": "green",
                "Tarjeta de débito": "yellow",
                "Tarjeta de servicios" : "blue",
                "Aplicación de anticipos" : "red",
                "Intermediario Pagos": 'purple',
                "Por definir": "gray"
            },
            loadingExcel: false,
            estatusBaja: []
        }
    },
    directives: {
       'dragscroll': dragscroll
    },
    created(){
        this.getEstatusAlumno()
    },
    methods: {
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await reportes.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(this.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        async getInfoIngreso() {
            const loading = this.$vs.loading()
            try {
                
                let params = {
                    "institucion": this.institucion,
                    "cicloEscolar": this.cicloEscolar,
                    "type_response": "file"
                }
                if(this.filtros.grupos != ''){
                    params.grupo = this.filtros.grupos
                }
                if(this.filtros.fuentesMovimiento != ''){
                    params.fuentesMovimiento = this.filtros.fuentesMovimiento
                }
                if(this.filtros.desde != ''){
                    params.fechaInicio = this.filtros.desde
                }
                if(this.filtros.hasta != ''){
                    params.fechaFinal = this.filtros.hasta
                }
                if(this.filtros.codigosDetalle != ''){
                    params.codigoDetalle = this.filtros.codigosDetalle
                }
                if(this.filtros.metodoPago != ''){
                    params.metodoPago = this.filtros.metodoPago
                }

                const response = await reportes.getReporteIngresos(params)
                loading.close()
                if(response){
                    this.openLoading(response.request.responseURL)
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                }
            }
            catch(error){
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: 'bottom-right',
                    title: 'Hubo un error inesperado'
                })
            }
        },
        getExcel () {
            this.loadingExcel = true
            let formData = {
                'institucion_id': this.institucion,
                'ciclo_escolar_id': this.cicloEscolar
            }
            formData.headers = ['persona_matricula', 'persona_nombre', 'persona_nivel_academico', 'persona_programa', 'ciclo', 'monto', 'concepto', 'fecha_vigencia_aplicacion', 'metodo_pago', 'fuente', 'facturado', 'tipo']
            if(this.filtros.grupos !== ''){
                formData.grupo_id = this.filtros.grupos
            }
            if(this.filtros.facturacion !== ''){
                formData.tipo = this.filtros.facturacion
            }
            if(this.filtros.desde !== ''){
                formData.desde = this.filtros.desde
            }
            if(this.filtros.hasta !== ''){
                formData.hasta = this.filtros.hasta
            }
            this.loading = true
            setTimeout(() => {
                axios.get('/reportes/file-ingresos', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    // console.log(e)
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
        getFacturado(value){
             if (value.facturado){
                return 'Facturado'
            }else{
                return 'No facturado'
            }
        },
        getColor(status){
            if (status === 'Facturado'){
                return `col-${this.statusColores[status]}`
            }else {
                return `col-${this.statusColores[status]}`
            }
        },
        getColorMetodo(status){
            if (status.metodoPago === 'Transferencia eléctronica de fondos'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Cheque nominativo'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>